import { ContactRole } from '../models/InvestmentEntityContact';
import { EntityType } from '../models/InvestmentEntity';

export interface ContactRequirement {
  role: ContactRole;
  required: boolean;
  maxCount?: number;
  description: string;
}

/**
 * Get contact requirements based on entity type
 */
export const getContactRequirements = (entityType: EntityType): ContactRequirement[] => {
  const baseRequirements: ContactRequirement[] = [
    {
      role: 'OWNER',
      required: false,
      description: 'Primary owner of the entity',
    },
    {
      role: 'REPRESENTATIVE',
      required: false,
      description: 'Representative or advisor for the entity',
    },
  ];

  // For now, all entity types have the same basic requirements
  // This can be expanded in the future for specific entity type rules
  switch (entityType) {
    case 'INDIVIDUAL':
      return [
        {
          role: 'OWNER',
          required: false,
          maxCount: 1,
          description: 'Individual owner',
        },
        {
          role: 'REPRESENTATIVE',
          required: false,
          description: 'Representative or advisor',
        },
      ];

    case 'PARTNERSHIP':
    case 'COMPANY':
    case 'TRUST':
    case 'SMSF':
      return baseRequirements;

    default:
      return baseRequirements;
  }
};
